<template>
  <assessment-mode-placeholder
    :badge-text="$t('app.assessment_mode.coming_soon.badge')"
    :description="$t('app.assessment_mode.voice.description')"
    :icon="mdiMicrophoneOutline"
    :title="$t('app.assessment_mode.selection.voice.title')"
  />
</template>

<script>
import { mdiMicrophoneOutline } from '@mdi/js'
import AssessmentModePlaceholder from '@/components/AssessmentMode/AssessmentModePlaceholder'

export default {
  name: 'VoiceMode',
  components: {
    AssessmentModePlaceholder,
  },
  data() {
    return {
      mdiMicrophoneOutline,
    }
  },
}
</script>
